export enum AlertType
{
  Success = 1,
  Warning,
  Error,
  Information,
}

export enum InfoType
{
  Normal = 1
}

export enum DialogType
{
  Normal = 1,
  Advise
}

export enum OptionType
{
  Positive = 1,
  Negative
}